const ID = 'connect';

export default ID;
